export * from './cloudProvider.registry';
export * from './CloudProviderLogo';
export * from './providerSelection/providerSelection.service';
export * from './providerService.delegate';
export * from './versionedCloudProvider.service';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/cloudProvider/index.ts